import React from 'react';
import { styled } from '@mui/material';
import { isUndefined } from 'lodash';
import { ITheme } from 'theme/types';
import SubTitleText from './SubTitleText';
import TitleText from './TitleText';
import { CircleIconWithTextProps } from './types';

const PREFIX = 'CircleIconWithText';

const classes = {
  imageContainerCircle: `${PREFIX}-imageContainerCircle`,
  alternativeImageContainerCircle: `${PREFIX}-alternativeImageContainerCircle`,
  icon: `${PREFIX}-icon`,
  content: `${PREFIX}-content`,
  title: `${PREFIX}-title`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.imageContainerCircle}`]: {
    width: '5.375rem',
    height: '5.375rem',
    borderRadius: '100%',
    backgroundColor: theme.palette.primary.main,
    margin: '0 auto',
    marginTop: 15,
  },

  [`& .${classes.alternativeImageContainerCircle}`]: {
    width: '5.375rem',
    height: '5.375rem',
    borderRadius: '100%',
    backgroundColor: 'rgb(230,242,253)',
    margin: '0 auto',
    marginTop: '1rem',
  },

  [`& .${classes.icon}`]: {
    color: theme.palette.white,
    paddingTop: '1.7rem',
  },

  [`& .${classes.content}`]: {
    marginTop: '0.8em',
    marginBottom: '1em',
  },

  [`& .${classes.title}`]: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
    fontWeight: 'bolder',
    paddingBottom: '0.5rem',
  },
}));

const CircleIconWithText = (props: CircleIconWithTextProps) => {
  const { children, title, subTitle, alternative, titleArray } = props;

  return (
    <Root>
      <div className={alternative ? classes.alternativeImageContainerCircle : classes.imageContainerCircle}>
        <div className={classes.icon}>{children}</div>
      </div>
      <div className={classes.content}>
        <h1 className={classes.title}>
          <TitleText title={title} titleArray={titleArray} />
        </h1>
        {!isUndefined(subTitle) && <SubTitleText subTitle={subTitle} />}
      </div>
    </Root>
  );
};

export default CircleIconWithText;
